import config from '../config'
import client from './client'

/**
 * Generic text generation. Prompt and options are chosen by the caller.
 * @param {{ prompt: string, systemPrompt?: string, responseFormat?: 'json_object' | 'text', model?: 'gpt-4o-mini' | 'gpt-5-nano' }} params
 * @returns {Promise<{ ok: boolean, data?: { content: string }, data?: { error: string } }>}
 */
const generateText = (params) => {
  const { prompt, systemPrompt, responseFormat, model } = params || {}
  const body = { prompt }
  if (systemPrompt != null) body.systemPrompt = systemPrompt
  if (responseFormat != null) body.responseFormat = responseFormat
  if (model != null) body.model = model
  return client.post(config.serverUrl + 'admin/text-generate', body)
}

export default { generateText }
